import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { findContentFromFile } from "../../../api/manual-import";
import { V3GenericErrorHandler } from "../../../api/error-handler";

export const getFindContentFromFileMutation = () => useMutation({
    mutationFn: findContentFromFile,
    onError: V3GenericErrorHandler(toast.error),
});